<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="840px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="服务名称："
        prop="serviceName">
        <el-input v-model="info.serviceName"></el-input>
      </el-form-item>
      <el-form-item
        label="服务概述："
        prop="serviceDesc">
        <el-input
          v-model="info.serviceDesc"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 5}"></el-input>
      </el-form-item>
      <el-form-item
        label="咨询电话："
        prop="contactPhone">
        <el-input v-model="info.contactPhone"></el-input>
      </el-form-item>
      <el-form-item
        label="服务封面："
        prop="topImage">
        <upload-with-crop
          v-model="info.topImage"
          cropper
          :isLt2M="200"
          :fixedNumber="[58,27]"
          :autoCropWidth="290"
          :autoCropHeight="135"></upload-with-crop>
      </el-form-item>
      <el-form-item
        label="图文详情："
        prop="detailImages">
        <desc-images
          v-model="info.detailImages"
          edit></desc-images>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import DescImages from '@/components/public/desc-images.vue'
import UploadWithCrop from '../../components/public/upload-with-crop.vue'
export default {
  name: 'EditServiceModal',
  components: { DescImages, UploadWithCrop },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        luxuryServiceId: null,
        serviceName: '',
        serviceDesc: '',
        contactPhone: '',
        topImage: [],
        detailImages: []
      },
      rules: {
        serviceName: [
          { required: true, message: '请输入鉴定服务名称', trigger: 'blur' },
          { max: 30, message: '鉴定服务名称长度最多 30 个字符', trigger: 'blur' }
        ],
        serviceDesc: [
          { required: true, message: '请输入鉴定服务概述', trigger: 'blur' },
          { max: 200, message: '鉴定服务概述长度最多 200 个字符', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入咨询电话', trigger: 'blur' }
        ],
        topImage: [
          { required: true, message: '请上传鉴定服务封面', trigger: 'blur' }
        ],
        detailImages: [
          { required: true, message: '请上传鉴定服务图文详情', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const luxuryServiceId = this.info.luxuryServiceId
      return (luxuryServiceId ? '编辑' : '新增') + '鉴定服务'
    },
    serviceProvinceCode() {
      return this.info.area[0] || null
    },
    serviceCityCode() {
      return this.info.area[1] || null
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        luxuryServiceId: null,
        serviceName: '',
        contactPhone: '',
        serviceDesc: '',
        topImage: [],
        detailImages: []
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.luxuryServiceId
            ? 'updateluxuryservice'
            : 'addluxuryservice'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info,
              topImage: this.info.topImage.map(i => i.url).join(','),
              detailImages: this.info.detailImages.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.$message.success('保存成功')
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add() {
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
